import React from 'react';
import { Hash, Volume2, ArrowLeft } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { servers } from '../../data/servers';
import { cn } from '../../lib/utils';

export function ChannelList() {
  const location = useLocation();
  const navigate = useNavigate();
  
  // Get the current server and channel from the URL
  const pathParts = location.pathname.split('/').filter(Boolean);
  const currentPath = pathParts[1] || 'chat';
  const currentChannel = pathParts[3];
  const serverKey = `/${currentPath}`;
  const currentServer = servers[serverKey] || servers['/'];
  const isContentView = pathParts.length > 3;

  // Debug logging
  console.log('Current URL:', location.pathname);
  console.log('Path parts:', pathParts);
  console.log('Current channel:', currentChannel);

  const handleChannelClick = (channel: string) => {
    navigate(`/app/${currentPath}/${channel}`);
  };

  return (
    <div className="w-full md:w-60 bg-background-secondary h-screen flex flex-col">
      <div className="p-4 border-b border-divider flex items-center gap-3">
        {isContentView && (
          <button 
            onClick={() => navigate(-1)}
            className="md:hidden p-2 hover:bg-background-tertiary rounded-full"
          >
            <ArrowLeft size={20} />
          </button>
        )}
        <h2 className="text-text-primary font-bold">{currentServer.name}</h2>
      </div>
      
      <div className="flex-1 p-4 overflow-y-auto">
        <div className="mb-4">
          <h3 className="text-text-secondary text-sm font-bold mb-2">TEXT-KANÄLE</h3>
          <div className="space-y-1">
            {currentServer.textChannels.map((channel) => (
              <button
                key={channel}
                onClick={() => handleChannelClick(channel)}
                className={cn(
                  "flex items-center w-full px-2 py-1 rounded transition-colors",
                  currentChannel === channel
                    ? "bg-accent-primary/10 text-accent-primary"
                    : "text-text-secondary hover:text-text-primary hover:bg-background-tertiary"
                )}
              >
                <Hash size={18} className="mr-2" />
                {channel}
              </button>
            ))}
          </div>
        </div>
        
        {currentServer.voiceChannels.length > 0 && (
          <div>
            <h3 className="text-text-secondary text-sm font-bold mb-2">SPRACH-KANÄLE</h3>
            <div className="space-y-1">
              {currentServer.voiceChannels.map((channel) => (
                <button
                  key={channel}
                  onClick={() => handleChannelClick(channel)}
                  className={cn(
                    "flex items-center w-full px-2 py-1 rounded transition-colors",
                    currentChannel === channel
                      ? "bg-accent-primary/10 text-accent-primary"
                      : "text-text-secondary hover:text-text-primary hover:bg-background-tertiary"
                  )}
                >
                  <Volume2 size={18} className="mr-2" />
                  {channel}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}